/**
 * @file
 */

import { isPageValid } from "@/common/validation/utils.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeDLSecureBorrowerAutoDebitPaidAheadPage() {
  customValidationInit(false);
  aspControlValidationInit();

  $('.responsiveTable').DataTable({
    "responsive": {
      "details": {
        display: $.fn.dataTable.Responsive.display.childRowImmediate,
        type: ''
      }
    },
    "scrollX": false,
    "paging": false,
    "searching": false,
    "ordering": false,
    "info": false
  });

  // the first column still has a tabindex of 0 making it tabbable even though the grid is set to always
  // display open and never have the +/- icons.  To fix this tab issue a class was applied to the first column
  // and we use jquery to set it's tabindex to -1
  $('.firstColumn').attr('tabindex', -1);

  // the responsive datatables js package is creating copy of the column that it moves to the expanded section.  At
  // that point there are 2 txtAdditional textboxes.  To work around having duplicate id's we will change the id
  // of the visible textbox along with it's label.
  // make the visible textbox unique
  AddVisibleToId();

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.CheckConsent = CheckConsent;
}

function CheckConsent() {
   if (isPageValid()) {
      var msg;

      // if the Paid Ahead section is visible then the confirm box message needs to change a bit
      if ($("[id$='divPaidAhead']").length == 1)
         msg = "Are you sure you want to change your additional amount withdrawn and/or your additional payment status?";
      else if ($("[id$='divPayAddAmtStatus']").length == 1) 
         msg = "Are you sure you want to change your paid ahead status?";
      else
         msg = "Are you sure you want to change your additional amount withdrawn?";

      var result = confirm(msg);
      return result;
   } else {
      return false;
   }
}

function AddVisibleToId() {
   // the responsive datatables js package is creating copy of the column that it moves to the expanded section.  At
   // that point there are 2 txtAdditional textboxes.  To work around having duplicate id's we will change the id
   // of the visible textbox along with it's label.
   // make the visible textbox unique
   var txtAdditionalVisible = $("[id*='txtAdditional']");
   var txtAdditionalVisibleId;
   var lblAdditionalAmountVisible = $("[id*='lblAdditionalAmount']");
   var lblAdditionalAmountVisibletId;
   var i;

   for (i = 0; i < $("[id*='txtAdditional']").length; i += 2) {
      txtAdditionalVisibleId = txtAdditionalVisible[i + 1].id;
      txtAdditionalVisibleId = txtAdditionalVisibleId.replace("txtAdditional", "txtAdditional_Visible");
      txtAdditionalVisible[i + 1].id = txtAdditionalVisibleId;

      // also make the associated label unique
      lblAdditionalAmountVisibletId = lblAdditionalAmountVisible[i + 1].id;
      lblAdditionalAmountVisibletId = lblAdditionalAmountVisibletId.replace("lblAdditionalAmount", "lblAdditionalAmount_Visible");
      lblAdditionalAmountVisible[i + 1].id = lblAdditionalAmountVisibletId;
      $("[id*='" + lblAdditionalAmountVisibletId + "']").attr("for", txtAdditionalVisibleId);
   }
}
